
<div *ngFor="let treeRoot of nodes"
     class="layout vertical left top" style="width: 100%; padding: 0 20px;">
    <ng-container *ngIf="treeRoot.showInPrivateMenu && treeRoot.id != 'dashboard'">
        <div *ngIf="!treeRoot.hidden"
             style="width: 100%; margin: 30px 10px 0 10px; font-size: large; color: #005a9e;" 
             class="layout horizontal left middle">
            <app-icon [id]="treeRoot.icon"></app-icon>
            {{treeRoot.label|translate}}
        </div>
        <div class="layout horizontal left top" style="width: 100%; height: 100%;"> 
            <div class="layout horizontal left top" style="width: 100%; flex-wrap: wrap;"> 
                <div *ngFor="let item of treeRoot.children" class="tile">
                    <app-dashboard-totalizer *ngIf="!item.hidden" [iconId]="item.icon" [counter]="25" [label]="item.shortLabel|translate" [caption]="item.label|translate" [url]="item.url"></app-dashboard-totalizer>
                </div>
            </div>
        </div>
    </ng-container>
</div>



